import { render, staticRenderFns } from "./SecondTag.vue?vue&type=template&id=70d4f68b&scoped=true&"
import script from "./SecondTag.vue?vue&type=script&lang=js&"
export * from "./SecondTag.vue?vue&type=script&lang=js&"
import style0 from "./SecondTag.vue?vue&type=style&index=0&id=70d4f68b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d4f68b",
  null
  
)

export default component.exports